import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=69bcbec6&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcbec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69bcbec6')) {
      api.createRecord('69bcbec6', component.options)
    } else {
      api.reload('69bcbec6', component.options)
    }
    module.hot.accept("./Record.vue?vue&type=template&id=69bcbec6&scoped=true", function () {
      api.rerender('69bcbec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/ProductConfig/tabItem/Record.vue"
export default component.exports